import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/aranco.webp';
import screenshot_target from '../../../images/letterfunnel/arnoknoops.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Arno Knoops"
      firstname="Arno"
      companyname="Aranco"
      competition="Boer & Croon en Turner"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/arnoknoops.js